import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../providers/ApiClientProvider";

export interface ManualCount {
    deviceId: string;
    total: number;
    upstream: number;
    downstream: number;
}

interface ManualCountResp {
    data: ManualCount[];
}

export const useFetchManualCount = (siteId: string | undefined, deploymentId: string | undefined) => {
    const apiClient = useApiClient();

    return useQuery({
        queryKey: ["manual-count", siteId, deploymentId],
        queryFn: async ({ signal }) => {
            const response = await apiClient.get<ManualCountResp>(
                `/sites/${siteId}/deployments/${deploymentId}/manual-counts`,
                { signal },
            );
            return response.data;
        },
        enabled: !!siteId && !!deploymentId,
    });
};
